module.exports = __webpack_public_path__ + "img/portugal-genitourinary-diseases-female.5adcec98.png";